<template>
    <span>
        {{ amountToDisplay }}
        <Tooltip 
            v-if="$validateText(tooltipText)" 
            :data="tooltipText" 
        />
    </span>
</template>

<script>
import Tooltip from '@/components/features/Tooltip.vue';
export default {
    components: {
        Tooltip
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        dataType: {
            type: String,
            required: false,
            default: ''
        },
        dataDisplay: {
            type: String,
            required: false,
            default: ''
        },
        dataKey: {
            type: String,
            required: false,
            default: 'amountString'
        },
        fixedAmount: {
            type: String,
            required: false,
            default: null
        },
        firstTimeOfferEnabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        hasFirstTimeOffer() { 
            return this.firstTimeOfferEnabled && this.model.hasFirstTimeOffer;
        },
        firstTimeOfferString() {
            const freeAmountTo = this.$translate('interest_free_days_free_amount_to');
            const freeAmountFrom = this.$translate('interest_free_days_free_amount_from');
            return this.model.getFirstTimeOfferString(freeAmountTo, freeAmountFrom);
        },
        fixedLoanAmount() {
            return this.fixedAmount;
        },
        loanAmount() {
            const modelKey = this.$getAlternateDataKeys(this.dataType, this.dataDisplay)[this.dataKey];
            return this.model[modelKey];
        },
        tooltipText() {
            if (this.fixedLoanAmount) {
                return this.loanAmount;
            }
            if (this.dataType === 'debt_collection' && this.dataDisplay === 'tooltip' && this.model.hasDebtCollectionAmount) {
                return this.$translate('debt_collection_amount_tooltip', 'Vid ett samlingslån gäller istället {amount}')
                    .replace('{amount}', this.model.amountDebtCollectionString);
            }
            if (this.hasFirstTimeOffer) {
                return this.firstTimeOfferString;
            }
            return null;
        },
        amountToDisplay() {
            return this.fixedLoanAmount 
                ? this.$format.currency(this.fixedLoanAmount)
                : this.loanAmount;
        }
    }
};
</script>